import { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsColumn = (props: Props) => {
  const { children, withBorder, centered } = props;

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [
    styles.container,
    withBorder ? styles.withBorder : undefined,
    centered ? styles.containerCentered : undefined,
  ];

  // ─────────────────────────────────────────────────────────────────────

  return <View style={containerStyles}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '50%',
  },
  containerCentered: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  withBorder: {
    borderRightWidth: 1,
    borderRightColor: theme.colors.DARK_KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  withBorder?: boolean;
  centered?: boolean;
} & PropsWithChildren;
